<template>
	<v-dialog
		content-class="overlay-container"
		width="800"
		v-model.sync="openState">
		<template v-if="contentComponent">
			<component :is="contentComponent"/>
		</template>
		<template v-else>
			Loading...
		</template>
	</v-dialog>
</template>


<script>
	import { mapState } from 'vuex'

	export default {
		name: 'overlay-container',

		data:() => ({
			contentComponent: null
		}),

		computed: {
			...mapState({
				content: state => state.ui.overlay.content
			}),

			openState: {
				get() { return this.$store.state.ui.overlay.openState },
				set(val) { this.$store.dispatch('VUEX_UI_HIDE_OVERLAY') }
			}
		},

		created() {
			this.loadContent()
		},

		methods: {
			loadContent() {
				this.contentComponent = (this.content) ? this.$root.loadComponent(this.content) : null
			}
		},

		watch: {
			content: {
				deep: true,
				handler() {
					this.loadContent()	
				}
			}
		}

	}
</script>